import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { CoffeePassStickyBanner, CoffeePassExitPopup } from './CoffeePassPromo';

export default function Layout() {
  const location = useLocation();
  const [bannerVisible, setBannerVisible] = useState(true);
  
  // Don't show Coffee Pass promo on the Coffee Pass page itself or on the Share page
  // Share page should focus only on sharing, not upselling
  const showCoffeePassPromo = !['/bula-coffee-club', '/share'].includes(location.pathname);
  
  // Check if banner was dismissed
  useEffect(() => {
    const wasDismissed = sessionStorage.getItem('coffeePassBannerDismissed');
    setBannerVisible(!wasDismissed && showCoffeePassPromo);
  }, [showCoffeePassPromo]);
  
  // Set CSS variable for banner height
  useEffect(() => {
    const root = document.documentElement;
    if (bannerVisible) {
      root.style.setProperty('--banner-height', '44px');
    } else {
      root.style.setProperty('--banner-height', '0px');
    }
  }, [bannerVisible]);
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* Sticky Coffee Pass Banner - sits above navbar */}
      {showCoffeePassPromo && <CoffeePassStickyBanner onDismiss={() => setBannerVisible(false)} />}
      
      <Navbar />
      <main className="flex-1" style={{ paddingTop: bannerVisible ? '44px' : '0' }}>
        <Outlet />
      </main>
      <Footer />
      
      {/* Exit Intent Popup */}
      {showCoffeePassPromo && <CoffeePassExitPopup />}
    </div>
  );
}
